import NOT_FOUNDiMAGE from "@/assets/images/404/404_illustration.png";
import { Link } from "react-router-dom";
import OrangeInfoIcon from "@/assets/icons/OrangeIcon.svg";
const NOT_FOUND_PAGE = () => {
  return (
    <div className="h-screen flex flex-col justify-center items-center">
      <div className="absolute  bg-[#F1F1F1] rounded-full  text-[#475467] top-3 right-4 flex items-center text-[14px] px-4 py-1 gap-x-2">
        <OrangeInfoIcon />
        <p>
          If this keeps happening, please feel free to contact our support team. {' '}
          <a  href="mailto:support@passionbits.io" className="text-[#ED5E00] font-medium">Contact Support</a>
        </p>
      </div>
      <div className="flex flex-col justify-center text-center items-center ">
        <img className="max-w-[254px] mb-4 mx-auto" src={NOT_FOUNDiMAGE} alt="" />
        <h2 className="text-[24px] font-semibold pt-[35px] pb-[17px] text-[#101828] ">
          Oops! Page Not Found
        </h2>
        <p className="text-[16px] text-[#475467] ">
          Looks like this page is a lost scene, but we'll get you back to the
          action.
        </p>
        <div className="mt-[20px]">
          <Link to={"/"}>
            {" "}
            <button className="text-[#ED5E00] text-[16px] font-medium px-[16px] py-[8px] ">
              Go to Homepage
            </button>{" "}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NOT_FOUND_PAGE;
